import { render } from "./CustomerOrderDetailsComponent.vue?vue&type=template&id=3d971f36"
import script from "./CustomerOrderDetailsComponent.vue?vue&type=script&lang=js"
export * from "./CustomerOrderDetailsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/customers/CustomerOrderDetailsComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d971f36"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d971f36', __exports__)) {
    api.reload('3d971f36', __exports__)
  }
  
  module.hot.accept("./CustomerOrderDetailsComponent.vue?vue&type=template&id=3d971f36", () => {
    api.rerender('3d971f36', render)
  })

}


export default __exports__